import type React from 'react';
import SvgIcon from './SvgIcon';

const BankSvg: React.FC = ({
  ariaLabel,
}:{
  ariaLabel?: string;
}) => (
  <SvgIcon
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={ariaLabel}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4V9H16V14H18V20H0V14H2V9H0V4L9 0L18 4ZM9 2.19L2 5.3V7H16V5.3L9 2.19ZM8 9V14H10V9H8ZM6 9H4V14H6V9ZM2 16V18H16V16H2ZM12 14H14V9H12V14ZM10 5C10 5.55228 9.55228 6 9 6C8.44771 6 8 5.55228 8 5C8 4.44772 8.44771 4 9 4C9.55228 4 10 4.44772 10 5Z"
      fill="currentColor"
      fillOpacity="0.9"
    />
  </SvgIcon>
);

export default BankSvg;
